import React from 'react';
import RatingInput from '../components/RatingInput';
import BackButton from '../components/BackButton';

function ClinicRatingPage({handleCleanRating, handleWaitRating, handleAccessRating, handleBack}) {
  
  return (
    <div className='w-screen h-screen justify-items-center content-center p-10'>
      <img className='absolute top-0 right-10 w-1/4 h-auto' src={process.env.PUBLIC_URL + '/logo.png'} alt='logo'/>
      <h1 className='justify-self-start text-2xl font-bold italic mb-10 underline'>How would you rate your clinic experience?</h1>
        <div className='w-full flex items-center justify-between' >
          <div className='w-1/3 justify-items-center'>
            <h1 className='w-fit border border-black px-6 py-2 font-bold text-2xl'>Cleanliness</h1>
          </div>
          <div className='grow'>
            <RatingInput handleRating={handleCleanRating} size='small' />
          </div>
        </div>

        <hr className='my-5 border-1 w-screen border-black' />
        <div className='w-full flex items-center justify-between'>
          <div className='w-1/3 justify-items-center'>
            <h1 className='w-fit border border-black px-6 py-2 font-bold text-nowrap text-2xl'>Waiting Time</h1>
          </div>
          <div className='grow'>
            <RatingInput handleRating={handleWaitRating} size='small' />
          </div>
        </div>

        <hr className='my-5 border-1 w-screen border-black' />
        <div className='w-full flex items-center justify-between'>
          <div className='w-1/3 justify-items-center'>
            <h1 className='w-fit border border-black px-6 py-2 font-bold text-nowrap text-2xl'>Accessibility</h1>
          </div>
          <div className='grow'>
            <RatingInput handleRating={handleAccessRating} size='small' />
          </div>
        </div>
        <BackButton handleBack={handleBack} />
    </div>
  );
}

export default ClinicRatingPage;